<template>
    <div class="overflow-hidden relative h-[382px] w-[508px]">
        <transition-group name="fade" tag="div" class="relative h-full w-full">
            <img v-for="(img, index) in imgArray" v-show="index === currentIndex" :key="img.key" :src="img.src"
                class="absolute top-0 left-0 h-[382px] w-[508px]" />
        </transition-group>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

const imgArray = ref([
    { key: 0, src: '/assets/images/functype/allTools/newImgs/upload_Photo_Maker.webp' },
    { key: 1, src: '/assets/images/functype/allTools/newImgs/upload_Photo_Maker-2.webp' },
    { key: 2, src: '/assets/images/functype/allTools/newImgs/upload_Photo_Maker-3.webp' }
]);

const currentIndex = ref(0);
const currentImg = computed(() => imgArray.value[currentIndex.value]);

let interval;

onMounted(() => {
    interval = setInterval(() => {
        currentIndex.value = (currentIndex.value + 1) % imgArray.value.length;
    }, 3000);
});

onUnmounted(() => {
    clearInterval(interval);
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>